import React from 'react';
import { Stack, Typography, TypographyProps } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';

interface ReportTitleProps extends TypographyProps {
    text: string;
    showInfo?: boolean;
    onPressInfo?: () => void;
}

const ReportTitle: React.FunctionComponent<ReportTitleProps> = (props) => {
    const { text, showInfo, onPressInfo = () => null, ...otherProps } = props;

    return (
        <Stack direction="row" spacing={1} alignItems="center">
            {showInfo && (
                <IconButton onClick={onPressInfo} size="small">
                    <InfoIcon color="warning" fontSize="small" />
                </IconButton>
            )}
            <Typography color="gray" {...otherProps}>
                {text}
            </Typography>
        </Stack>
    );
};

export default ReportTitle;
